(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, state, machinery, RxOptions, rxLayer, map, layerManager, truthStripToolbar, loader) {
      var ref;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.machinery = machinery;
      this.RxOptions = RxOptions;
      this.rxLayer = rxLayer;
      this.map = map;
      this.layerManager = layerManager;
      this.truthStripToolbar = truthStripToolbar;
      this.loader = loader;
      this.gotoStep = bind(this.gotoStep, this);
      this._findStepIndex = bind(this._findStepIndex, this);
      this.gotoPrevStep = bind(this.gotoPrevStep, this);
      this.gotoNextStep = bind(this.gotoNextStep, this);
      this.exitProcess = bind(this.exitProcess, this);
      this.save = bind(this.save, this);
      this.setValidity = bind(this.setValidity, this);
      this.rxLayer.reset();
      this.preload_on_state_change = false;
      SidebarController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.rx = this.rxLayer.data;
      this.scope.spp = this.RxOptions.retrieve('spp');
      this.scope.is_from_spp = this.RxOptions.exists('spp');
      this.scope.referer = this.RxOptions.retrieve('from_state');
      this.scope.pp_planter = this.RxOptions.retrieve('planter');
      this.scope.aborted = false;
      this.scope.is_valid = false;
      this.scope.show_fullpage = true;
      this.scope.gotoStep = this.gotoStep;
      this.scope.gotoNextStep = this.gotoNextStep;
      this.scope.gotoPrevStep = this.gotoPrevStep;
      this.scope.exitProcess = this.exitProcess;
      this.scope.setValidity = this.setValidity;
      this.scope.save = this.save;
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.loader.hideAll();
        };
      })(this));
      if (this.state.params.id != null) {
        this.RxOptions.store('id', this.state.params.id);
        this.scope.rx.id = this.state.params.id;
      }
      if ((this.scope.rx.id == null) && (this.RxOptions.retrieve('spp_id') == null)) {
        this.scope.aborted = true;
        this.exitProcess();
        return;
      }
      if (this.scope.is_from_spp) {
        this.scope.btnText = 'Fit Seed to Field';
      } else {
        this.scope.btnText = 'Cancel';
      }
      this.scope.averagePop = this.rxLayer.averagePop;
      this.scope.steps = [
        {
          name: 'Product Planter',
          state: 'grower.planting-rx.products',
          fullpage: true
        }, {
          name: 'Layers',
          state: 'grower.planting-rx.layers'
        }, {
          name: 'Prescription Map',
          state: 'grower.planting-rx.prescription',
          wide: true,
          showNameOnButton: true
        }
      ];
      this.scope.repos = {
        seed_companies: null,
        brands: null,
        treatments: null,
        planters: null
      };
      this.machinery.planters((ref = this.scope.spp) != null ? ref.cropID : void 0).then((function(_this) {
        return function(response) {
          var i, len, planter, ref, results;
          _this.scope.repos.planters = response.data.data;
          if (_this.scope.is_from_spp && _this.scope.pp_planter !== null) {
            ref = _this.scope.repos.planters;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              planter = ref[i];
              if (planter.id === _this.scope.pp_planter) {
                results.push(_this.scope.rx.planter = planter);
              } else {
                results.push(void 0);
              }
            }
            return results;
          }
        };
      })(this));
      this.scope.$on('planting-rx:step-loading', (function(_this) {
        return function() {
          return _this.load_msg = _this.loader.overMapAndSidebar('Loading...');
        };
      })(this));
      this.scope.$on('planting-rx:step-ready', (function(_this) {
        return function() {
          return _this.load_msg.hide();
        };
      })(this));
      this.rxLayer.loadFromStorage(this.RxOptions).then((function(_this) {
        return function(response) {
          var step;
          _this.scope.rx.previous_visual_layers = _.clone(_this.scope.rx.visual_layers);
          _this.scope.rx.previous_calculation = _this.rxLayer.asSolverOptions();
          _this.scope.show_preloader = false;
          if (!_this.scope.rx.fields_id) {
            _this.exitProcess();
            return;
          }
          _this.setUpMap();
          if (_.endsWith(_this.state.current.name, 'planting-rx')) {
            _this.gotoStep(_this.scope.steps[0]);
          } else {
            step = _this.scope.steps.filter(function(step) {
              return _this.state.is(step.state);
            })[0];
            if (step != null) {
              _this.gotoStep(step);
            }
          }
          return _this.scope.$broadcast('rx:loaded');
        };
      })(this));
    }


    /*
     * Since each Step itself decides validity, we need a way for
     * the child steps to tell us if they are valid. Obviously, we could
     * let them directly play with our is_valid scope variable, but a
     * method feels nicer, and seems more flexible for if we change
     * away from relying on the $parent scope relationship for this.
     */

    SidebarController.prototype.setValidity = function(value) {
      return this.scope.is_valid = value;
    };


    /*
     * Initializes some stuff we need for the map portions of this process
     */

    SidebarController.prototype.setUpMap = function() {
      this.mapLayer = this.map.createFeatureGroup();
      this.map.add(this.mapLayer, null, 'field-boundary');
      this.layerManager.get('Field').display({
        id: this.scope.rx.fields_id
      }, this.mapLayer, {
        color: '#00FF00',
        fillOpacity: 0.0
      }).then((function(_this) {
        return function() {
          _this.map.centerOn(_this.mapLayer);
          return _this.truthStripToolbar.reset();
        };
      })(this));
      return this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.map.remove(_this.mapLayer);
        };
      })(this));
    };

    SidebarController.prototype.save = function() {
      var save_msg;
      save_msg = this.loader.overMapAndSidebar('Saving Prescription...');
      return this.rxLayer.save().then((function(_this) {
        return function(resp) {
          var exit_data, ref, ref1;
          save_msg.hide();
          if (((ref = resp.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'success') {
            exit_data = $.extend({}, resp.data.data);
            exit_data.hybrids = _this.rxLayer.getHybrids();
            return _this.exitProcess(exit_data);
          }
        };
      })(this));
    };

    SidebarController.prototype.exitProcess = function(exit_data) {
      if (this.RxOptions.exists('spp')) {
        this.RxOptions.retrieve('spp').dialog.show();
        if (exit_data) {
          $(window).trigger('rx:completed', exit_data);
        }
      }
      if (this.scope.referer) {
        return this.state.go(this.scope.referer);
      } else {
        return this.state.go('grower.data');
      }
    };

    SidebarController.prototype.gotoNextStep = function() {
      var next;
      next = this._findStepIndex(this.scope.activeStep.name) + 1;
      this.scope.$broadcast('rx:steps-next');
      return this.gotoStep(this.scope.steps[next]);
    };

    SidebarController.prototype.gotoPrevStep = function() {
      var prev;
      prev = this._findStepIndex(this.scope.activeStep.name) - 1;
      if (prev < 0) {
        return this.exitProcess();
      } else {
        this.scope.$broadcast('rx:steps-prev');
        return this.gotoStep(this.scope.steps[prev]);
      }
    };

    SidebarController.prototype._findStepIndex = function(name) {
      var i, ind, len, ref, step;
      ref = this.scope.steps;
      for (ind = i = 0, len = ref.length; i < len; ind = ++i) {
        step = ref[ind];
        if (step.name === name) {
          return ind;
          break;
        }
      }
    };

    SidebarController.prototype.gotoStep = function(step) {
      if (this.scope.activeStep != null) {
        this.scope.activeStep.active = false;
      }
      this.scope.activeStep = step;
      step.active = true;
      step.visited = true;
      this.state.go(step.state, null, {
        location: false
      });
      if (step.fullpage) {
        return this.scope.show_fullpage = true;
      } else {
        return this.scope.show_fullpage = false;
      }
    };

    return SidebarController;

  })(Controller);

}).call(this);
